import { Redirect, useLocalSearchParams } from 'expo-router';
import { ScrollView, View } from 'react-native';

import { VerifyEmailForm } from '@/components/verify-email-form';

export default function VerifyEmailScreen() {
  const { email, returnTo } = useLocalSearchParams<{
    email?: string;
    returnTo?: string | string[];
  }>();

  if (!email) {
    return <Redirect href="/(public)/sign-up" />;
  }

  return (
    <ScrollView
      keyboardShouldPersistTaps="handled"
      contentContainerClassName="items-center justify-center p-4 py-8 sm:flex-1 sm:p-6 sm:py-4"
      contentInsetAdjustmentBehavior="automatic"
      keyboardDismissMode="interactive"
      className="flex-1 bg-background"
    >
      <View className="w-full max-w-sm">
        <VerifyEmailForm email={email} returnTo={returnTo} />
      </View>
    </ScrollView>
  );
}
